// Modal components for dashboard - matching the style from AvisosUsuario, NoticiasUsuario, etc.
import React from 'react';
import { API_BASE } from '../../../../api';

const getImageUrl = (path) => {
    if (!path) return null;
    if (path.startsWith("http") || path.startsWith("data:")) return path;
    const baseUrl = API_BASE.replace(/\/api\/?$/, "");
    return `${baseUrl}${path}`;
};

const PLACEHOLDER_IMAGE = "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='400' height='250' viewBox='0 0 400 250'%3E%3Crect fill='%23E5E7EB' width='400' height='250'/%3E%3Cpath fill='%239CA3AF' d='M163 142.5l24-24 24 24 48-48 48 48V187H163v-44.5zm48-39.5c-8.3 0-15-6.7-15-15s6.7-15 15-15 15 6.7 15 15-6.7 15-15 15z'/%3E%3C/svg%3E";

export const AvisoModal = ({ aviso, onClose }) => {
    if (!aviso) return null;

    const getNivelLabel = (nivel) => {
        switch (nivel) {
            case "alta": return "Alta";
            case "media": return "Media";
            default: return "Baja";
        }
    };

    return (
        <div
            style={{
                position: 'fixed',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                backgroundColor: 'rgba(0, 0, 0, 0.5)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                zIndex: 1000
            }}
            onClick={onClose}
        >
            <div
                style={{
                    backgroundColor: 'white',
                    borderRadius: '12px',
                    width: '90%',
                    maxWidth: '800px',
                    maxHeight: '90vh',
                    display: 'flex',
                    flexDirection: 'column',
                    boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)'
                }}
                onClick={(e) => e.stopPropagation()}
            >
                {/* Modal Header */}
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '1.5rem 2rem', borderBottom: '1px solid #e2e8f0' }}>
                    <h2 style={{ margin: 0, fontSize: '1.25rem', fontWeight: 600, color: '#1e293b' }}>
                        Detalle del aviso
                    </h2>
                    <button
                        type="button"
                        onClick={onClose}
                        style={{
                            background: 'none',
                            border: 'none',
                            fontSize: '2rem',
                            lineHeight: 1,
                            color: '#64748b',
                            cursor: 'pointer'
                        }}
                    >
                        ×
                    </button>
                </div>

                {/* Modal Content - Scrollable */}
                <div style={{ padding: '2rem', overflowY: 'auto' }}>
                    {/* Imagen */}
                    {aviso.imagen && (
                        <div style={{ marginBottom: '1.5rem', borderRadius: '8px', overflow: 'hidden' }}>
                            <img
                                src={getImageUrl(aviso.imagen) || PLACEHOLDER_IMAGE}
                                alt={aviso.titulo}
                                style={{
                                    width: '100%',
                                    height: 'auto',
                                    maxHeight: '400px',
                                    objectFit: 'cover',
                                    display: 'block'
                                }}
                                onError={(e) => {
                                    if (e.target.src !== PLACEHOLDER_IMAGE) {
                                        e.target.src = PLACEHOLDER_IMAGE;
                                    }
                                }}
                            />
                        </div>
                    )}

                    {/* Meta info */}
                    <div style={{ display: 'flex', alignItems: 'center', gap: '1rem', marginBottom: '1.5rem', flexWrap: 'wrap' }}>
                        <span
                            className={`intra-badge-level intra-badge-level--${aviso.nivel}`}
                            style={{
                                padding: '0.5rem 1rem',
                                borderRadius: '12px',
                                fontSize: '0.875rem',
                                fontWeight: 600,
                            }}
                        >
                            {getNivelLabel(aviso.nivel)} prioridad
                        </span>
                        {aviso.fechaInicio && (
                            <span style={{ fontSize: '0.875rem', color: '#64748b' }}>
                                <strong>Publicado:</strong> {new Date(aviso.fechaInicio).toLocaleDateString('es-MX', { year: 'numeric', month: 'long', day: 'numeric' })}
                            </span>
                        )}
                        {aviso.fechaFin && (
                            <span style={{ fontSize: '0.875rem', color: '#64748b' }}>
                                <strong>Vigente hasta:</strong> {new Date(aviso.fechaFin).toLocaleDateString('es-MX', { year: 'numeric', month: 'long', day: 'numeric' })}
                            </span>
                        )}
                    </div>

                    {/* Título */}
                    <h3 style={{
                        fontSize: '1.5rem',
                        fontWeight: 600,
                        color: '#1e293b',
                        margin: '0 0 1rem 0',
                        lineHeight: 1.3
                    }}>
                        {aviso.titulo}
                    </h3>

                    {/* Mensaje completo */}
                    <div style={{
                        fontSize: '1rem',
                        color: '#475569',
                        lineHeight: 1.6,
                        whiteSpace: 'pre-wrap'
                    }}>
                        {aviso.mensaje}
                    </div>

                    {/* Área responsable */}
                    {aviso.area && (
                        <div style={{
                            marginTop: '1.5rem',
                            padding: '1rem',
                            backgroundColor: '#f8fafc',
                            borderRadius: '8px',
                            border: '1px solid #e2e8f0'
                        }}>
                            <p style={{ fontSize: '0.875rem', color: '#64748b', margin: 0 }}>
                                <strong>Área responsable:</strong> {aviso.area}
                            </p>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export const NoticiaModal = ({ noticia, onClose }) => {
    if (!noticia) return null;

    const formatFechaCorta = (fechaStr) => {
        if (!fechaStr) return "";
        const d = new Date(fechaStr);
        if (Number.isNaN(d.getTime())) return fechaStr;
        return d.toLocaleDateString('es-MX', { year: 'numeric', month: 'long', day: 'numeric' });
    };

    return (
        <div
            style={{
                position: 'fixed',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                backgroundColor: 'rgba(0, 0, 0, 0.5)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                zIndex: 1000
            }}
            onClick={onClose}
        >
            <div
                style={{
                    backgroundColor: 'white',
                    borderRadius: '12px',
                    width: '90%',
                    maxWidth: '900px',
                    maxHeight: '90vh',
                    display: 'flex',
                    flexDirection: 'column',
                    boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)'
                }}
                onClick={(e) => e.stopPropagation()}
            >
                {/* Modal Header */}
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '1.5rem 2rem', borderBottom: '1px solid #e2e8f0' }}>
                    <h2 style={{ margin: 0, fontSize: '1.25rem', fontWeight: 600, color: '#1e293b' }}>
                        Detalle de Noticia
                    </h2>
                    <button
                        type="button"
                        onClick={onClose}
                        style={{
                            background: 'none',
                            border: 'none',
                            fontSize: '2rem',
                            lineHeight: 1,
                            color: '#64748b',
                            cursor: 'pointer'
                        }}
                    >
                        ×
                    </button>
                </div>

                {/* Modal Content - Scrollable */}
                <div style={{ padding: '2rem', overflowY: 'auto' }}>
                    {/* Imagen */}
                    {noticia.imagen && (
                        <div style={{ marginBottom: '1.5rem', borderRadius: '8px', overflow: 'hidden' }}>
                            <img
                                src={getImageUrl(noticia.imagen) || PLACEHOLDER_IMAGE}
                                alt={noticia.titulo}
                                style={{
                                    width: '100%',
                                    height: 'auto',
                                    maxHeight: '450px',
                                    objectFit: 'cover',
                                    display: 'block'
                                }}
                                onError={(e) => {
                                    if (e.target.src !== PLACEHOLDER_IMAGE) {
                                        e.target.src = PLACEHOLDER_IMAGE;
                                    }
                                }}
                            />
                        </div>
                    )}

                    {/* Meta info */}
                    <div style={{ display: 'flex', alignItems: 'center', gap: '1rem', marginBottom: '1rem' }}>
                        <span style={{
                            padding: '0.25rem 0.75rem',
                            borderRadius: '12px',
                            fontSize: '0.75rem',
                            fontWeight: 600,
                            backgroundColor: '#dbeafe',
                            color: '#1e40af'
                        }}>
                            {noticia.area || "Corporativo"}
                        </span>
                        {noticia.tipoNoticia && (
                            <span style={{
                                fontSize: '0.7rem',
                                fontWeight: '700',
                                padding: '4px 10px',
                                borderRadius: '12px',
                                textTransform: 'uppercase',
                                backgroundColor: noticia.tipoNoticia === 'Alta' ? '#FEE2E2' : noticia.tipoNoticia === 'Media' ? '#FEF3C7' : '#E0F2FE',
                                color: noticia.tipoNoticia === 'Alta' ? '#B91C1C' : noticia.tipoNoticia === 'Media' ? '#B45309' : '#0369A1'
                            }}>
                                {noticia.tipoNoticia}
                            </span>
                        )}
                        {noticia.fechaPublicacion && (
                            <span style={{ fontSize: '0.875rem', color: '#64748b' }}>
                                {formatFechaCorta(noticia.fechaPublicacion)}
                            </span>
                        )}
                    </div>

                    {/* Título */}
                    <h3 style={{
                        fontSize: '1.75rem',
                        fontWeight: 600,
                        color: '#1e293b',
                        margin: '0 0 1rem 0',
                        lineHeight: 1.3
                    }}>
                        {noticia.titulo}
                    </h3>

                    {/* Resumen */}
                    {noticia.resumen && (
                        <p style={{
                            fontSize: '1.125rem',
                            color: '#64748b',
                            fontStyle: 'italic',
                            marginBottom: '1.5rem',
                            lineHeight: 1.6
                        }}>
                            {noticia.resumen}
                        </p>
                    )}

                    {/* Contenido */}
                    <div style={{
                        fontSize: '1rem',
                        color: '#374151',
                        lineHeight: 1.7
                    }} dangerouslySetInnerHTML={{ __html: noticia.contenido || noticia.descripcion || "Sin contenido disponible" }} />
                </div>
            </div>
        </div>
    );
};

export const ArticuloModal = ({ articulo, onClose }) => {
    if (!articulo) return null;

    const formatFechaCorta = (fechaStr) => {
        if (!fechaStr) return "";
        const d = new Date(fechaStr);
        if (Number.isNaN(d.getTime())) return fechaStr;
        return d.toLocaleDateString('es-MX', { year: 'numeric', month: 'long', day: 'numeric' });
    };

    return (
        <div
            style={{
                position: 'fixed',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                backgroundColor: 'rgba(0, 0, 0, 0.5)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                zIndex: 1000
            }}
            onClick={onClose}
        >
            <div
                style={{
                    backgroundColor: 'white',
                    borderRadius: '12px',
                    width: '90%',
                    maxWidth: '900px',
                    maxHeight: '90vh',
                    display: 'flex',
                    flexDirection: 'column',
                    boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)'
                }}
                onClick={(e) => e.stopPropagation()}
            >
                {/* Modal Header */}
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '1.5rem 2rem', borderBottom: '1px solid #e2e8f0' }}>
                    <h2 style={{ margin: 0, fontSize: '1.25rem', fontWeight: 600, color: '#1e293b' }}>
                        Detalle del Artículo
                    </h2>
                    <button
                        type="button"
                        onClick={onClose}
                        style={{
                            background: 'none',
                            border: 'none',
                            fontSize: '2rem',
                            lineHeight: 1,
                            color: '#64748b',
                            cursor: 'pointer'
                        }}
                    >
                        ×
                    </button>
                </div>

                {/* Modal Content - Scrollable */}
                <div style={{ padding: '2rem', overflowY: 'auto' }}>
                    {/* Imagen */}
                    {articulo.imagen && (
                        <div style={{ marginBottom: '1.5rem', borderRadius: '8px', overflow: 'hidden' }}>
                            <img
                                src={getImageUrl(articulo.imagen) || PLACEHOLDER_IMAGE}
                                alt={articulo.titulo}
                                style={{
                                    width: '100%',
                                    height: 'auto',
                                    maxHeight: '450px',
                                    objectFit: 'cover',
                                    display: 'block'
                                }}
                                onError={(e) => {
                                    if (e.target.src !== PLACEHOLDER_IMAGE) {
                                        e.target.src = PLACEHOLDER_IMAGE;
                                    }
                                }}
                            />
                        </div>
                    )}

                    {/* Meta info */}
                    <div style={{ display: 'flex', alignItems: 'center', gap: '1rem', marginBottom: '1rem', flexWrap: 'wrap' }}>
                        {articulo.categoria && (
                            <span style={{
                                padding: '0.25rem 0.75rem',
                                borderRadius: '12px',
                                fontSize: '0.75rem',
                                fontWeight: 600,
                                backgroundColor: '#fef3c7',
                                color: '#92400e'
                            }}>
                                {articulo.categoria}
                            </span>
                        )}
                        {articulo.autor && (
                            <span style={{ fontSize: '0.875rem', color: '#64748b' }}>
                                <strong>Por:</strong> {articulo.autor}
                            </span>
                        )}
                        {articulo.fechaPublicacion && (
                            <span style={{ fontSize: '0.875rem', color: '#64748b' }}>
                                {formatFechaCorta(articulo.fechaPublicacion)}
                            </span>
                        )}
                    </div>

                    {/* Título */}
                    <h3 style={{
                        fontSize: '1.75rem',
                        fontWeight: 600,
                        color: '#1e293b',
                        margin: '0 0 1rem 0',
                        lineHeight: 1.3
                    }}>
                        {articulo.titulo}
                    </h3>

                    {/* Resumen */}
                    {articulo.resumen && (
                        <p style={{
                            fontSize: '1.125rem',
                            color: '#64748b',
                            fontStyle: 'italic',
                            marginBottom: '1.5rem',
                            lineHeight: 1.6
                        }}>
                            {articulo.resumen}
                        </p>
                    )}

                    {/* Contenido */}
                    <div style={{
                        fontSize: '1rem',
                        color: '#374151',
                        lineHeight: 1.7
                    }} dangerouslySetInnerHTML={{ __html: articulo.contenido || articulo.descripcion || "Sin contenido disponible" }} />
                </div>
            </div>
        </div>
    );
};

export const ForoModal = ({ foro, onClose, onViewFull }) => {
    if (!foro) return null;

    return (
        <div
            style={{
                position: 'fixed',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                backgroundColor: 'rgba(0, 0, 0, 0.5)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                zIndex: 1000
            }}
            onClick={onClose}
        >
            <div
                style={{
                    backgroundColor: 'white',
                    borderRadius: '12px',
                    width: '90%',
                    maxWidth: '800px',
                    maxHeight: '90vh',
                    display: 'flex',
                    flexDirection: 'column',
                    boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)'
                }}
                onClick={(e) => e.stopPropagation()}
            >
                {/* Modal Header */}
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '1.5rem 2rem', borderBottom: '1px solid #e2e8f0' }}>
                    <h2 style={{ margin: 0, fontSize: '1.25rem', fontWeight: 600, color: '#1e293b' }}>
                        Vista previa del foro
                    </h2>
                    <button
                        type="button"
                        onClick={onClose}
                        style={{
                            background: 'none',
                            border: 'none',
                            fontSize: '2rem',
                            lineHeight: 1,
                            color: '#64748b',
                            cursor: 'pointer'
                        }}
                    >
                        ×
                    </button>
                </div>

                {/* Modal Content - Scrollable */}
                <div style={{ padding: '2rem', overflowY: 'auto' }}>
                    {/* Imagen */}
                    {foro.imagen && (
                        <div style={{ marginBottom: '1.5rem', borderRadius: '8px', overflow: 'hidden' }}>
                            <img
                                src={getImageUrl(foro.imagen) || PLACEHOLDER_IMAGE}
                                alt={foro.titulo}
                                style={{
                                    width: '100%',
                                    height: 'auto',
                                    maxHeight: '400px',
                                    objectFit: 'cover',
                                    display: 'block'
                                }}
                                onError={(e) => {
                                    if (e.target.src !== PLACEHOLDER_IMAGE) {
                                        e.target.src = PLACEHOLDER_IMAGE;
                                    }
                                }}
                            />
                        </div>
                    )}

                    {/* Meta info */}
                    <div style={{ display: 'flex', alignItems: 'center', gap: '1rem', marginBottom: '1rem' }}>
                        {foro.categoria && (
                            <span style={{
                                padding: '0.25rem 0.75rem',
                                borderRadius: '12px',
                                fontSize: '0.75rem',
                                fontWeight: 600,
                                backgroundColor: '#e0e7ff',
                                color: '#3730a3'
                            }}>
                                {foro.categoria}
                            </span>
                        )}
                        {foro.respuestas !== undefined && (
                            <span style={{ fontSize: '0.875rem', color: '#64748b' }}>
                                💬 {foro.respuestas} respuestas
                            </span>
                        )}
                    </div>

                    {/* Título */}
                    <h3 style={{
                        fontSize: '1.5rem',
                        fontWeight: 600,
                        color: '#1e293b',
                        margin: '0 0 1rem 0',
                        lineHeight: 1.3
                    }}>
                        {foro.titulo}
                    </h3>

                    {/* Descripción */}
                    <p style={{
                        fontSize: '1rem',
                        color: '#374151',
                        lineHeight: 1.6,
                        whiteSpace: 'pre-wrap',
                        marginBottom: '1.5rem'
                    }}>
                        {foro.descripcionInicial || foro.descripcion}
                    </p>

                    {/* Botón para ver discusión completa */}
                    <button
                        onClick={() => {
                            onClose();
                            onViewFull(foro);
                        }}
                        style={{
                            width: '100%',
                            padding: '0.75rem 1.5rem',
                            backgroundColor: '#C92439',
                            color: '#fff',
                            border: 'none',
                            borderRadius: '8px',
                            cursor: 'pointer',
                            fontWeight: '600',
                            fontSize: '1rem',
                            transition: 'all 0.2s ease'
                        }}
                        onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#a01d2e'}
                        onMouseLeave={(e) => e.currentTarget.style.backgroundColor = '#C92439'}
                    >
                        Ver discusión completa →
                    </button>
                </div>
            </div>
        </div>
    );
};

// Helper para fecha flexible, duplicado aqui para el modal independiente
const parseDateTimeFlexible = (fechaStr) => {
    if (!fechaStr) return null;
    let fecha = new Date(fechaStr);
    if (!isNaN(fecha.getTime())) return fecha;
    // Intentar formato DD/MM/YYYY
    const parts = fechaStr.split('/');
    if (parts.length === 3) {
        // Asumiendo DD/MM/YYYY
        fecha = new Date(`${parts[2]}-${parts[1]}-${parts[0]}`);
        if (!isNaN(fecha.getTime())) return fecha;
    }
    return null;
};

// Styles Helpers copiados para el modal independiente
const getCategoriaClass = (categoria) => {
    if (!categoria) return "corporativo";
    const cat = categoria.toString().trim().toLowerCase();
    if (cat.includes("capacita")) return "capacitacion";
    if (cat === "rh" || cat.includes("recursos")) return "rh";
    if (cat.includes("finanza")) return "finanzas";
    if (cat.includes("auditor")) return "auditoria";
    if (cat.includes("cumple") || cat.includes("birthday")) return "cumpleanos";
    if (cat.includes("festiv") || cat.includes("holiday")) return "festivo";
    return "corporativo";
};

const getCategoriaStyles = (catName) => {
    const cls = getCategoriaClass(catName);
    switch (cls) {
        case 'corporativo': return { bg: '#DBEAFE', text: '#1E40AF', border: '#3B82F6' };
        case 'capacitacion': return { bg: '#FFEDD5', text: '#9A3412', border: '#F97316' };
        case 'rh': return { bg: '#F3E8FF', text: '#6B21A8', border: '#8B5CF6' };
        case 'finanzas': return { bg: '#DCFCE7', text: '#166534', border: '#10B981' };
        case 'auditoria': return { bg: '#FEE2E2', text: '#991B1B', border: '#EF4444' };
        case 'cumpleanos': return { bg: '#FCE7F3', text: '#9D174D', border: '#F472B6' };
        case 'festivo': return { bg: '#CCFBF1', text: '#0F766E', border: '#14B8A6' };
        default: return { bg: '#F1F5F9', text: '#475569', border: '#94A3B8' };
    }
};

export const EventoModal = ({ evento, onClose }) => {
    if (!evento) return null;

    return (
        <div
            style={{
                position: "fixed", top: 0, left: 0, width: "100%", height: "100%",
                backgroundColor: "rgba(0,0,0,0.5)", display: "flex", justifyContent: "center", alignItems: "center",
                zIndex: 1000, backdropFilter: "blur(2px)",
            }}
            onClick={onClose}
        >
            <div
                style={{
                    backgroundColor: "white", borderRadius: "1rem", padding: "2rem", width: "90%", maxWidth: "800px",
                    boxShadow: "0 25px 50px -12px rgba(0, 0, 0, 0.25)", position: "relative",
                    maxHeight: "90vh", overflowY: "auto",
                }}
                onClick={(e) => e.stopPropagation()}
            >
                <div className="intra-calendar-sidepanel-header" style={{ marginBottom: '1.5rem', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <h2 className="intra-avisos-section-title" style={{ margin: 0, fontSize: '1.25rem' }}>Detalle de evento</h2>
                    <button type="button" className="intra-button-ghost" onClick={onClose} style={{ fontSize: '1.5rem', lineHeight: 1, padding: '0.5rem', background: 'none', border: 'none', cursor: 'pointer' }}>✕</button>
                </div>

                <div className="intra-calendar-event-details">
                    {/* HEADER: Título y Categoría */}
                    <div className="intra-event-detail-section" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '2rem', borderBottom: '1px solid #f1f5f9', paddingBottom: '1.5rem' }}>
                        <h3 className="intra-event-detail-title" style={{ fontSize: '1.8rem', margin: 0, lineHeight: 1.2, color: '#1e293b' }}>{evento.titulo}</h3>
                        <span style={{
                            flexShrink: 0, padding: '0.4rem 1rem', borderRadius: '9999px', fontSize: '0.875rem', fontWeight: 600, marginLeft: '1rem',
                            height: 'fit-content', backgroundColor: getCategoriaStyles(evento.categoria).bg,
                            color: getCategoriaStyles(evento.categoria).text,
                            border: `1px solid ${getCategoriaStyles(evento.categoria).border}33`
                        }}>
                            {evento.categoria}
                        </span>
                    </div>

                    {/* GRID LAYOUT */}
                    <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '2rem' }}>
                        {/* COLUMNA IZQUIERDA: Metadatos */}
                        <div style={{ display: 'flex', flexDirection: 'column', gap: '1.5rem' }}>
                            {/* Horario */}
                            <div>
                                <label style={{ display: 'block', fontWeight: 700, marginBottom: '0.75rem', color: '#94a3b8', fontSize: '0.75rem', textTransform: 'uppercase', letterSpacing: '0.05em' }}>Horario</label>
                                <div style={{ background: '#f8fafc', padding: '1.25rem', borderRadius: '1rem', border: '1px solid #e2e8f0' }}>
                                    <div style={{ marginBottom: '1rem' }}>
                                        <div style={{ fontSize: '0.75rem', color: '#64748b', marginBottom: '0.25rem' }}>Inicio</div>
                                        <div style={{ fontWeight: 600, color: '#334155', fontSize: '1rem' }}>
                                            {evento.fechaInicio ? parseDateTimeFlexible(evento.fechaInicio).toLocaleString("es-MX", { dateStyle: "medium", timeStyle: "short" }) : "N/A"}
                                        </div>
                                    </div>
                                    <div style={{ borderTop: '1px solid #cbd5e1', paddingTop: '1rem' }}>
                                        <div style={{ fontSize: '0.75rem', color: '#64748b', marginBottom: '0.25rem' }}>Fin</div>
                                        <div style={{ fontWeight: 600, color: '#334155', fontSize: '1rem' }}>
                                            {evento.fechaFin ? parseDateTimeFlexible(evento.fechaFin).toLocaleString("es-MX", { dateStyle: "medium", timeStyle: "short" }) : "N/A"}
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* Responsable y Ubicación */}
                            <div style={{ display: 'grid', gap: '1.25rem' }}>
                                {evento.responsable && (
                                    <div>
                                        <label style={{ display: 'block', fontWeight: 700, marginBottom: '0.4rem', color: '#94a3b8', fontSize: '0.75rem', textTransform: 'uppercase', letterSpacing: '0.05em' }}>Responsable</label>
                                        <div style={{ display: 'flex', alignItems: 'center', gap: '0.75rem' }}>
                                            <div style={{ width: '32px', height: '32px', borderRadius: '50%', background: '#e2e8f0', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '1rem' }}>👤</div>
                                            <p style={{ margin: 0, fontWeight: 500, color: '#334155' }}>{evento.responsable}</p>
                                        </div>
                                    </div>
                                )}
                                {evento.ubicacion && (
                                    <div>
                                        <label style={{ display: 'block', fontWeight: 700, marginBottom: '0.4rem', color: '#94a3b8', fontSize: '0.75rem', textTransform: 'uppercase', letterSpacing: '0.05em' }}>Ubicación</label>
                                        <div style={{ display: 'flex', alignItems: 'center', gap: '0.75rem' }}>
                                            <div style={{ width: '32px', height: '32px', borderRadius: '50%', background: '#fef3c7', color: '#d97706', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '1rem' }}>📍</div>
                                            <p style={{ margin: 0, fontWeight: 500, color: '#334155' }}>{evento.ubicacion}</p>
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>

                        {/* COLUMNA DERECHA: Descripción */}
                        <div>
                            <label style={{ display: 'block', fontWeight: 700, marginBottom: '1rem', color: '#94a3b8', fontSize: '0.75rem', textTransform: 'uppercase', letterSpacing: '0.05em' }}>Descripción del evento</label>
                            <div style={{ color: '#334155', lineHeight: 1.7, fontSize: '1rem', whiteSpace: 'pre-wrap' }}>
                                {evento.descripcion || <span style={{ color: '#cbd5e1', fontStyle: 'italic' }}>Sin descripción adicional.</span>}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};
